import r from "./_createBaseFor.js";
var a = r();
const o = a;
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseFor.js
// module id = 904
// module chunks = 67